/**
 * @description Countdown timer
 * @param {String} header - text displayed above the timer
 * @param {Number} startTime - date of the event, in milliseconds
 * @param {Function} hide - callback function to hide the component
 **/

import React, { Component } from 'react';
import isPast from 'date-fns/is_past';
import { getDuration } from '~/tools/mll/helpers';
import './style.scss';

class Timer extends Component {
  state = {
    current: []
  }

  componentDidMount = () => {
    const eventTime = this.props.startTime;
    const currentTime = new Date().getTime();
    let difference = eventTime - currentTime;

    this.clock = setInterval(() => {
      difference -= 1000;
      let duration = getDuration(difference);

      this.setState({
        current: [
          { 'value': duration.getDays(), 'letter': 'D' },
          { 'value': duration.getHours(), 'letter': 'H' },
          { 'value': duration.getMinutes(), 'letter': 'M' },
          { 'value': duration.getSeconds(), 'letter': 'S' }
        ]
      })

      if (isPast(eventTime)) {
        clearInterval(this.clock);
        this.props.hide();
      }
    }, 1000);
  }

  componentWillUnmount = () => {
    clearInterval(this.clock);
  }

  render() {
    return (
      <div className='game-timer' style={{paddingTop: this.props.isPip ? '80px' : '50px' }}>
        { this.props.header && <span className='time-until' style={{fontSize: this.props.isPip ? '1.25em' : '0.9em' }}>{this.props.header}</span> }
        <div className='time-wrapper'>
          {this.state.current.map((el, i) => (
            <div className='time-block' key={i}>
              <span className='time-value'>{el.value}</span>
              <span className='time-letter'>{el.letter}</span>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

export default Timer;